import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

import { AuthenticationService } from '../services/auth.service';

@Injectable()
export class AdminAuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthenticationService
  ) {}

  async canActivate() {
    const user = this.authService.getCurrentUser();

    if (
      user &&
      ((user.isAdmin && user.roles.includes(3)) ||
        user?.roles.includes(9) ||
        user?.roles.includes(13))
    ) {
      return true;
    } else {
      await this.router.navigate(['/']);
      return false;
    }
  }
}
